const SS_TAGS_STORAGE_KEY = 'SS_TAGS_V1';

export const ssTags = {
  _read() {
    try { return JSON.parse(localStorage.getItem(SS_TAGS_STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  },
  _write(obj) {
    try { localStorage.setItem(SS_TAGS_STORAGE_KEY, JSON.stringify(obj)); } catch (e) {}
  },
  key(product, variantDetailId, frequency) {
    const pid = product?.productId || product?.campaignProductId || product?.id || 'p';
    const vid = Number(variantDetailId) || 0;
    const freq = frequency || 'OT';
    return `${pid}|${vid}|${freq}`;
  },
  get(sig) {
    const all = this._read();
    return all[sig] || null;
  },
  set(sig, value) {
    const all = this._read();
    all[sig] = value;
    this._write(all);
  },
  del(sig) {
    const all = this._read();
    if (sig in all) {
      delete all[sig];
      this._write(all);
    }
  }
};

export const findMatchingVariant = (subscribeProduct, oneTimeVariant) => {
  const list = subscribeProduct?.variants || [];
  if (!list.length) return null;
  if (oneTimeVariant?.variantDetailId) {
      const byId = list.find(v => v.variantDetailId === oneTimeVariant.variantDetailId);
      if (byId) return byId;
  }
  if (oneTimeVariant?.title) {
      const byTitle = list.find(v => v.title === oneTimeVariant.title);
      if (byTitle) return byTitle;
  }
  return list[0];
};

export const getIconType = (icon) => {
    const iconSplit = icon?.split("|") || []
    return iconSplit.length > 1 ? (iconSplit[0] || "standard") : "standard"
}

export const updateIconType = (icon, type) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    iconSplit[0] = type
    return iconSplit.join("|")
  }
  return `${type}|${icon}|`
}

export const getSVGIcon = (icon) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    return iconSplit[2]
  }
  return icon 
}

export const getStandardIcon = (icon) => {
  const iconSplit = icon?.split("|") || []
  if (iconSplit.length > 1) {
    return iconSplit[1]
  }
  return icon 
}

export const isCombinedIconValue = (icon) => {
  return ["svg", "standard"].includes(icon?.split("|")?.[0]);
}

export const updateIconValue = (type, currentIcon, newIcon) => {
    const iconSplit = currentIcon?.split("|") || []
    if (iconSplit.length > 1) {
        iconSplit[0] = type
        if (type === 'svg') {
            iconSplit[1] = getStandardIcon(currentIcon) || "";
            iconSplit[2] = newIcon || "";
        } else {
            iconSplit[1] = newIcon || "";
            iconSplit[2] = getSVGIcon(currentIcon) || "";
        }
        return iconSplit.slice(0, 3).join("|")
    }
    return type === 'svg' ? `${type}|${getStandardIcon(currentIcon) || ""}|${newIcon || ""}` : `${type}|${newIcon || ""}|${getSVGIcon(currentIcon) || ""}`
}

export const replaceWithRegexMap = (text, replacements) => {
  let result = text;

  replacements.forEach(({ regex, replaceWith }) => {
    result = result.replace(regex, replaceWith);
  });

  return result;
};
